<template>
  <v-layout row wrap>
    <v-flex xs2>
      <v-text-field v-model="tag.name" :rules="[emptyTag]" />
    </v-flex>
    <v-flex xs2 pl-4>
      <v-text-field
        v-model.number="tag.ttlDay"
        @keydown.arrow-down.prevent
        @keydown.arrow-up.prevent
        @wheel.prevent
        :rules="[maxMinCondition, wholeNumber]"
        style="touch-action: none;"
        suffix="日"
        type="number"
      />
    </v-flex>
    <v-flex ml-3>
      <v-btn v-if="!canDelete" @click="$emit('deleteTag', index)" small fab>
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    tag: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: () => 0,
    },
    canDelete: {
      type: Boolean,
    },
  },
  data() {
    return {
      maxMinCondition: value =>
        (value <= 180 && value >= 1 && value !== Math.E) ||
        '1~180の間で入力してください',
      wholeNumber: value => value % 1 === 0 || '整数で入力してください',
      emptyTag: value => value != '' || 'タグ名称を入力して下さい',
    }
  },
}
</script>

<style></style>
